module.exports = __webpack_public_path__ + "assets/img/versatech.406fd68c.png";